import { MessageTypeEnum, PriorityEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, ManyToOne, JoinColumn, OneToMany, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';
import { BiMessage } from './bi-message.entity';

@Entity('module')
export class Modules {

    @PrimaryGeneratedColumn('increment', {
        name: 'module_id'
    })
    moduleId: number;

    @Column('varchar', {
        nullable: false,
        name: 'module_name',
        length: 20
    })
    moduleName: string;

    @Column("varchar", {
        nullable: false,
        name: "module_desc",
        length: 50
    })
    moduleDesc: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @OneToMany(type => BiMessage, biMsg => biMsg.module, { cascade: true })
    biMessages: BiMessage[];
}

